// Module
var code = "<div wt-popover template=\"connectionPointPopover.html\" item=\"vm.connectionPoint\"> <a ui-sref=\"moreTools.connectionPoints\" ng-class=\"{'disabled': vm.isEditMode}\" ng-if=\"!vm.isEditMode\"> <span>{{vm.connectionPoint.name}}</span> </a> <span ng-if=\"vm.isEditMode\"> <span>{{vm.connectionPoint.name}}</span> </span> </div>";
// Exports
module.exports = code;